/**
 * Automy.Core.Enums.Reporting.Filters.ReportFilterOperator
 * Native filter JSON `operator` (string token). Required on every filter.
 * No member 0. Distinct from process/RPA ComparisonOperator.
 */
export default Object.freeze({
  Equal: 'eq',
  NotEqual: 'neq',
  In: 'in',
  NotIn: 'not-in',
  GreaterThan: 'gt',
  GreaterThanOrEqual: 'gte',
  LessThan: 'lt',
  LessThanOrEqual: 'lte',
  Contains: 'contains',
  StartsWith: 'starts-with',
  Between: 'between',
  IsNull: 'is-null',
  IsNotNull: 'is-not-null',
  EndsWith: 'ends-with',
});
